import { GirlCreationModalComponent } from '../components/girl-creation-modal/girl-creation-modal.component';
import { SettingsDataService } from './communication_services/settingsData.service';
import { AnalyticsService } from './analytics/analytics.service';
import { PaywallService } from './paywall.service';
import { ModalsService } from './modals.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CreationGirlService {
  constructor(
    private _settingsDataService: SettingsDataService,
    private _analyticsService: AnalyticsService,
    private _paywallService: PaywallService,
    private _modalsService: ModalsService,
  ) {}

  public tryOpenPopup(): void {
    this._analyticsService.girlCreationTryOpen();

    if (
      this._settingsDataService.isPremiumActive ||
      this._settingsDataService.updateSettingsData$.value.freeCustomAiChatCount
    ) {
      this._analyticsService.girlCreationPopupOpen();
      this._modalsService.openModal(GirlCreationModalComponent).subscribe();
    } else {
      this._paywallService.showPaywall('girl_creation').subscribe();
    }
  }
}
